export default function Footer() {
    return (
        <div id="Footer">
            <div className="FooterContent">
                <div className={"FooterContentTitle"}>
                    <div>
                        <img src="/logo512.png" alt="logo" className='uxnetworkLogo'/>
                        <h1>
                            UX-NETWORK
                        </h1>
                    </div>
                    <p>
                        The new and innovative Network System for Creators and Companies to connect.
                    </p>
                    <div className="gap-2">
                        <a href="https://hq.uxnetwork.eu/" target={"_blank"}>HQ</a>
                        <a href="https://mail.uxnetwork.eu/" target={"_blank"}>MAIL</a>
                        <a href="https://panel.uxnetwork.eu/" target={"_blank"}>PANEL</a>
                        <a href="https://cloud.uxnetwork.eu/" target={"_blank"}>CLOUD</a>
                        <a href="https://media.uxnetwork.eu/" target={"_blank"}>MEDIA</a>
                    </div>
                </div>
            </div>
            <div className={"FooterCopyright"}>
                Copyright © {new Date().getFullYear()} UX - All rights reserved
            </div>
        </div>
    );
}